import { watch } from 'vue';
import type { TeamScanState } from './types';

/** 停止旧轮询并创建请求令牌；参数/弹窗/渠道变化后异步响应不能写回。 */
export function beginTeamScan(state: TeamScanState): () => boolean {
  if (state.corporateOrderLoading) return () => false;
  state.clearTimer();
  const requestId = ++state.scanRequestId;
  const paymentMethod = state.paymentMethod;
  const modalType = state.modalType;
  const form = JSON.stringify(state.formData);
  state.scanPaymentError = false;
  const isHostOpen = () =>
    state.modalOpen || state.productModalIsOpen || state.teamMemberPayModalOpen;
  const isActive = () => requestId === state.scanRequestId &&
    paymentMethod === state.paymentMethod && modalType === state.modalType &&
    form === JSON.stringify(state.formData) && !state.isUseCorporateTransfer && !state.corporateOrderLoading &&
    isHostOpen();
  // 同步观察每次变更，关闭再重开或 A→B→A 也不能让旧请求复活。
  // 下次请求、参数变更、关闭弹窗都会解除当前监听，生命周期与请求对称。
  const stop = watch(() => [state.scanRequestId, state.paymentMethod, state.modalType,
    JSON.stringify(state.formData), state.modalOpen, state.productModalIsOpen, state.teamMemberPayModalOpen,
    state.isUseCorporateTransfer, state.corporateOrderLoading], () => {
    if (isActive()) return;
    stop();
    if (requestId === state.scanRequestId) state.clearTimer();
  }, { flush: 'sync' });
  return isActive;
}
